export const UPDATE_JOB_TITLE = "UPDATE_JOB_TITLE";
export const UPDATE_JOB_TYPE = "UPDATE_JOB_TYPE";
export const UPDATE_JOB_LOCATION = "UPDATE_JOB_LOCATION";
export const UPDATE_WORK_MODE = "UPDATE_WORK_MODE";
export const UPDATE_JOB_DESCRIPTION = "UPDATE_JOB_DESCRIPTION";
export const UPDATE_FUNCTIONAL_AREA = "UPDATE_FUNCTIONAL_AREA";
export const UPDATE_JOB_ROLE = "UPDATE_JOB_ROLE";
export const UPDATE_JOB = "UPDATE_JOB";
export const DELETE_JOB = "DELETE_JOB";
